import { v4 as uuidv4 } from 'uuid';
import { storageKeys } from '../preferences/storageKeys';

export async function getOrCreateDeviceId(): Promise<string> {
  if (typeof window !== 'undefined') {
    const existing = window.localStorage.getItem(storageKeys.deviceId);
    if (existing) {
      return existing;
    }
  }

  const created = uuidv4();
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(storageKeys.deviceId, created);
  }
  return created;
}
